export default async function({ props, graphql, state }) {
  const path = state.get(`media.currentFile`)
  const file = state.get(path)

  const groups = file.groups.map(group => {
    return `"${group}"`
  })

  const name = file.name
  const id = file.id
  const caption =
    file.metaData && file.metaData.caption ? file.metaData.caption : ''

  await graphql.mutate(`{
    editMedia(id: "${id}", name: "${name}", groups: [${groups.join()}], caption: "${caption.replace(
    /\n/g,
    '\\n'
  )}" ) {
      name
    }
  }`)
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/editMedia.js